module.exports = __webpack_public_path__ + "static/thumbnail-b8fc72561fdc57a5eeef82fd67221576.png";